var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
export var BUTTON_COLORS;
(function (BUTTON_COLORS) {
    BUTTON_COLORS["primary"] = "primary";
    BUTTON_COLORS["secondary"] = "secondary";
    BUTTON_COLORS["white"] = "white";
    BUTTON_COLORS["yellow"] = "yellow";
    BUTTON_COLORS["green"] = "green";
    BUTTON_COLORS["orange"] = "orange";
    BUTTON_COLORS["red"] = "red";
})(BUTTON_COLORS || (BUTTON_COLORS = {}));
export var BUTTON_SIZES;
(function (BUTTON_SIZES) {
    BUTTON_SIZES["small"] = "small";
    BUTTON_SIZES["medium"] = "medium";
})(BUTTON_SIZES || (BUTTON_SIZES = {}));
var TYPE_CLASS_NAMES;
(function (TYPE_CLASS_NAMES) {
    TYPE_CLASS_NAMES["primary"] = "bg-primary border-primary text-black";
    TYPE_CLASS_NAMES["primary-outlined"] = " border-primary text-primary hover:bg-primary hover:text-black";
    TYPE_CLASS_NAMES["secondary"] = "bg-neutral-2 border-neutral-3 text-neutral-6";
    TYPE_CLASS_NAMES["secondary-outlined"] = " border-neutral-3 text-neutral-3";
    TYPE_CLASS_NAMES["white"] = "bg-white border-black text-black";
    TYPE_CLASS_NAMES["white-outlined"] = "border-white text-white";
    TYPE_CLASS_NAMES["green"] = "bg-green border-black text-black";
    TYPE_CLASS_NAMES["green-outlined"] = " border-green text-green";
    TYPE_CLASS_NAMES["red"] = "bg-red border-black text-black";
    TYPE_CLASS_NAMES["red-outlined"] = " border-red text-red";
    TYPE_CLASS_NAMES["orange"] = "bg-orange border-black text-black";
    TYPE_CLASS_NAMES["orange-outlined"] = " border-orange text-orange";
    TYPE_CLASS_NAMES["yellow"] = "bg-yellow border-black text-black";
    TYPE_CLASS_NAMES["yellow-outlined"] = " border-unlockable text-neutral-6";
})(TYPE_CLASS_NAMES || (TYPE_CLASS_NAMES = {}));
export var Button = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.color, color = _d === void 0 ? BUTTON_COLORS.primary : _d, _e = _a.size, size = _e === void 0 ? BUTTON_SIZES.medium : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.outlined, outlined = _g === void 0 ? false : _g, className = _a.className, children = _a.children, component = _a.component, href = _a.href, props = __rest(_a, ["color", "size", "disabled", "outlined", "className", "children", "component", "href"]);
    var Component = component || 'button';
    var widthRegex = /\sw-[a-z0-9\/]+/g;
    var customWidth = (_b = className === null || className === void 0 ? void 0 : className.match(widthRegex)) === null || _b === void 0 ? void 0 : _b.length;
    var heightRegex = /\sh-[a-z0-9\/]+/g;
    var customHeight = (_c = className === null || className === void 0 ? void 0 : className.match(heightRegex)) === null || _c === void 0 ? void 0 : _c.length;
    var typeClasses = TYPE_CLASS_NAMES[outlined ? color + '-outlined' : color];
    var buttonClasses = clsx(disabled
        ? ['cursor-not-allowed bg-neutral-5 border-neutral-5 text-neutral-4']
        : ['cursor-pointer', typeClasses], customWidth || 'w-36', customHeight || (size === BUTTON_SIZES.medium ? 'h-10' : 'h-9'), 'border', 'font-medium', 'animation', 'duration-500', 'flex', 'justify-center', 'text-sm', 'px-4', 'rounded', 'outline-none', 'select-none', 'flex', 'items-center', className);
    var isLink = Component === 'a';
    var disabledProp = isLink ? {} : { disabled: disabled };
    var hrefProp = isLink ? (disabled ? {} : { href: href }) : {};
    return (React.createElement(Component, __assign({ className: buttonClasses }, disabledProp, hrefProp, props, { ref: ref }),
        React.createElement("span", { className: "truncate flex items-center" }, children)));
});
